"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaybookHistoryWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PlaybookHistoryWidgetComponent = function PlaybookHistoryWidgetComponent(_ref) {
  var playbookName = _ref.playbookName;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "rounded border px-2.5 py-2 my-1 max-w-[350px] bg-gray-50 border-gray-200 opacity-80",
    "data-sentry-component": "PlaybookHistoryWidgetComponent",
    "data-sentry-source-file": "PlaybookHistoryWidget.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center gap-1.5 mb-1.5",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArchiveIcon, {
        width: 12,
        height: 12,
        color: "#868e96",
        "data-sentry-element": "ArchiveIcon",
        "data-sentry-source-file": "PlaybookHistoryWidget.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-gray-500 text-xs font-medium",
        children: "Suggested Playbook"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "text-xs text-gray-500 leading-tight break-words",
      children: playbookName
    })]
  });
};
var PlaybookHistoryWidget = exports.PlaybookHistoryWidget = /*#__PURE__*/_react.default.memo(PlaybookHistoryWidgetComponent);